module.exports = __webpack_public_path__ + "lupa.svg?7077beac69c148c175033fc741039f5b";


//////////////////
// WEBPACK FOOTER
// ./assets/images/lupa.svg
// module id = 843
// module chunks = 0